module.exports = __webpack_public_path__ + "media/images/pic/kitty-group-e2d412f9e2af6e42c0f46597616778fa.png";